var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMerchantDashboardLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 28,
    viewBox: "0 0 19 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.49998 11.8996C10.5493 11.8996 11.4 11.049 11.4 9.99961C11.4 8.95027 10.5493 8.09961 9.49998 8.09961C8.45063 8.09961 7.59998 8.95027 7.59998 9.99961C7.59998 11.049 8.45063 11.8996 9.49998 11.8996Z",
    fill: "#9A999D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 0.5C4.26194 0.5 0 4.57609 0 9.58437C0 11.9695 1.08716 15.1413 3.23119 19.0119C4.95306 22.1196 6.94509 24.9298 7.98119 26.3281C8.15626 26.567 8.38517 26.7613 8.64936 26.8953C8.91355 27.0292 9.20558 27.099 9.50178 27.099C9.79798 27.099 10.09 27.0292 10.3542 26.8953C10.6184 26.7613 10.8473 26.567 11.0224 26.3281C12.0567 24.9298 14.0505 22.1196 15.7724 19.0119C17.9128 15.1425 19 11.9707 19 9.58437C19 4.57609 14.7381 0.5 9.5 0.5ZM9.5 13.8C8.74843 13.8 8.01374 13.5771 7.38883 13.1596C6.76393 12.742 6.27687 12.1486 5.98926 11.4542C5.70164 10.7598 5.62639 9.99578 5.77302 9.25866C5.91964 8.52153 6.28155 7.84443 6.81299 7.31299C7.34443 6.78155 8.02153 6.41964 8.75866 6.27302C9.49578 6.12639 10.2598 6.20164 10.9542 6.48926C11.6486 6.77687 12.242 7.26393 12.6596 7.88883C13.0771 8.51374 13.3 9.24843 13.3 10C13.2989 11.0075 12.8982 11.9734 12.1858 12.6858C11.4734 13.3982 10.5075 13.7989 9.5 13.8Z",
    fill: "#9A999D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMerchantDashboardLocationIcon);
export default __webpack_public_path__ + "static/media/merchant_dashboard_location_icon.7499e733341a8b62690f07cbef5a0c6f.svg";
export { ForwardRef as ReactComponent };